"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var toolkit_1 = require("@reduxjs/toolkit");
var ramda_1 = require("ramda");
var pomeranian_durations_1 = require("pomeranian-durations");
var utils_1 = require("../../utils/utils");
var getPpv_1 = __importDefault(require("./queries/getPpv"));
var config_1 = __importStar(require("../../config"));
var api_1 = require("../../utils/api");
var constants_1 = require("./constants");
var savePlaybackPosition_1 = __importDefault(require("./queries/savePlaybackPosition"));
var getShow_1 = require("./queries/getShow");
var getMovie_1 = __importDefault(require("./queries/getMovie"));
var addTitleBookmark_1 = __importDefault(require("./queries/addTitleBookmark"));
var removeTitleBookmark_1 = __importDefault(require("./queries/removeTitleBookmark"));
var selectors_1 = require("./selectors");
var getEpisode_1 = __importDefault(require("./queries/getEpisode"));
var selectors_2 = require("../devices/selectors");
exports.getEpisodesFromSeasons = ramda_1.pipe(ramda_1.pluck('episodes'), ramda_1.filter(ramda_1.pipe(ramda_1.isNil, ramda_1.not)), ramda_1.unnest);
exports.fetchBrand = function (_a) {
    var brandId = _a.brandId, isShow = _a.isShow, isPpv = _a.isPpv, initialRailSize = _a.initialRailSize;
    return function (dispatch, getState) {
        var deviceId = selectors_2.getSerialNumber(getState());
        var query;
        if (isShow) {
            query = getShow_1.GET_SHOW(undefined, initialRailSize);
        }
        else if (isPpv) {
            query = getPpv_1.default;
        }
        else {
            query = getMovie_1.default();
        }
        return dispatch(api_1.createApiAction(constants_1.FETCH_BRAND, {
            baseURL: config_1.default.EXP_API_URL + config_1.GRAPH_QL_PATH,
            params: {
                query: query,
                variables: { brandId: brandId, deviceId: utils_1.isNotNilOrEmpty(deviceId) ? deviceId : null },
            },
            meta: { isShow: isShow, brandId: brandId, isPpv: isPpv },
            authenticated: true,
            graphQL: true,
        }));
    };
};
exports.fetchShowHighlights = function (brandId, nextPageSize) { return function (dispatch, getState) {
    var _a;
    var highlights = selectors_1.showHighlights(getState())(brandId);
    var endCursor = (_a = highlights === null || highlights === void 0 ? void 0 : highlights.pageInfo) === null || _a === void 0 ? void 0 : _a.endCursor;
    return dispatch(api_1.createApiAction(constants_1.FETCH_SHOW_HIGHLIGHTS, {
        baseURL: config_1.default.EXP_API_URL + config_1.GRAPH_QL_PATH,
        params: {
            query: getShow_1.GET_SHOW_HIGHLIGHTS(nextPageSize, endCursor),
            variables: { brandId: brandId },
        },
        meta: { brandId: brandId },
        authenticated: true,
        graphQL: true,
    }));
}; };
exports.savePlaybackPosition = function (assetId, position) {
    return api_1.createApiAction(constants_1.SAVE_PLAYBACK_POSITION, {
        baseURL: config_1.default.EXP_API_URL + config_1.GRAPH_QL_PATH,
        params: {
            query: savePlaybackPosition_1.default,
            variables: {
                assetId: assetId,
                position: utils_1.isNilOrEmpty(position) || ramda_1.lte(position, 0) ? 'PT0S' : pomeranian_durations_1.fromSeconds(position),
            },
        },
        meta: { assetId: assetId },
        authenticated: true,
        graphQL: true,
    });
};
exports.selectSeason = function (brandId, selectedSeasonId) {
    return toolkit_1.createAction(constants_1.SELECT_SEASON)({
        brandId: brandId,
        selectedSeasonId: selectedSeasonId,
    });
};
exports.addToMyList = function (brandId) {
    return api_1.createApiAction(constants_1.MY_LIST, {
        baseURL: config_1.default.EXP_API_URL + config_1.GRAPH_QL_PATH,
        params: {
            query: addTitleBookmark_1.default,
            variables: { titleId: brandId },
        },
        meta: { brandId: brandId, isAdded: true },
        authenticated: true,
        graphQL: true,
    });
};
exports.removeFromMyList = function (brandId) {
    return api_1.createApiAction(constants_1.MY_LIST, {
        baseURL: config_1.default.EXP_API_URL + config_1.GRAPH_QL_PATH,
        params: {
            query: removeTitleBookmark_1.default,
            variables: { titleId: brandId },
        },
        meta: { brandId: brandId, isAdded: false },
        authenticated: true,
        graphQL: true,
    });
};
// for downloads
exports.setBrand = function (brand) { return toolkit_1.createAction(constants_1.SET_BRAND)(brand); };
// This function will use grapgql query episode(id) to fetch episode details
// for specific episode id.
exports.fetchEpisodeById = function (episodeId) {
    return api_1.createApiAction(getEpisode_1.default, {
        baseURL: config_1.default.EXP_API_URL + config_1.GRAPH_QL_PATH,
        params: {
            query: getEpisode_1.default,
            variables: { episodeId: episodeId },
        },
        authenticated: true,
        graphQL: true,
    });
};
//# sourceMappingURL=actions.js.map